var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1522_233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 150,
    height: 150,
    rx: 75,
    fill: "black",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7981 78.6631L49.1448 101.722V80.6213H43V108.972C43 110.649 44.373 112 46.0779 112H74.7562V105.965H53.5285L77.1124 82.9628L72.7981 78.6631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.539 46.0139C113.539 45.2046 113.237 44.4399 112.666 43.8886C112.106 43.3153 111.334 43 110.539 43L82.5105 43.011L82.5214 49.0373H103.42L80.9883 72.1319L85.2867 76.3371L107.55 53.4111V74.5482H113.55V46.0127L113.539 46.0139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.236 45.0315V43H44.0102C43.4426 43 43 43.4537 43 44.0213V73.236H45.0204V45.0307L73.236 45.0315Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.549 110.978V81.7637H111.571V109.968H84.0898V112H112.556C113.119 112 113.551 111.545 113.551 110.978L113.549 110.978Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7981 78.6631L49.1448 101.722V80.6213H43V108.972C43 110.649 44.373 112 46.0779 112H74.7562V105.965H53.5285L77.1124 82.9628L72.7981 78.6631Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.539 46.0139C113.539 45.2046 113.237 44.4399 112.666 43.8886C112.106 43.3153 111.334 43 110.539 43L82.5105 43.011L82.5214 49.0373H103.42L80.9883 72.1319L85.2867 76.3371L107.55 53.4111V74.5482H113.55V46.0127L113.539 46.0139Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.236 45.0315V43H44.0102C43.4426 43 43 43.4537 43 44.0213V73.236H45.0204V45.0307L73.236 45.0315Z",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.549 110.978V81.7637H111.571V109.968H84.0898V112H112.556C113.119 112 113.551 111.545 113.551 110.978L113.549 110.978Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1522_233",
    x: -11,
    y: -11,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1522_233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1522_233",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/Fullscreen-icon.59a65eb56d665b76d04cb667a7fbb8e6.svg";
export { ForwardRef as ReactComponent };